import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  FaLinkedin,
  FaGithub,
  FaEnvelope,
  FaBuilding,
  FaInfo
} from 'react-icons/fa';

function Footer() {

  const REACT_APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
  const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || 'info@accurati.xx';
  console.log('REACT_APP_VERSION', REACT_APP_VERSION);

  return (
    <footer className="site-footer">
      <div className="footer-top">
        <Container>
          <Row className="align-items-center">
            <Col lg={4} md={12} className="mb-5 mb-lg-0">
              <div className="footer-logo">
                <img src="/images/accurati-logo-v3-white.png" alt="AccuraTI Logo" className="footer-logo-img" />
              </div>
              <p className="footer-about">
                Tailored software engineering and technical consulting services for custom applications, cloud infrastructure, and embedded/IoT systems.
              </p>
              <div className="footer-social">
                <a href="https://linkedin.com/company/accurati" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaLinkedin />
                </a>
                <a href="https://github.com/accurati" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <FaGithub />
                </a>
              </div>
            </Col>

            <Col lg={2} md={4} sm={6} className="mb-4 mb-md-0">
              <h3 className="footer-heading">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/home#home" onClick={(e) => { e.preventDefault(); document.getElementById('home').scrollIntoView({ behavior: 'smooth' }); }}>Home</a></li>
                <li><a href="/home#about" onClick={(e) => { e.preventDefault(); document.getElementById('about').scrollIntoView({ behavior: 'smooth' }); }}>About</a></li>
                <li><a href="/home#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}>Services</a></li>
                <li><a href="/home#contact" onClick={(e) => { e.preventDefault(); document.getElementById('contact').scrollIntoView({ behavior: 'smooth' }); }}>Contact</a></li>
              </ul>
            </Col>

            <Col lg={3} md={4} sm={6} className="mb-4 mb-md-0">
              <h3 className="footer-heading">Services</h3>
              <ul className="footer-links">
                <li><a href="/#services" onClick={(e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }}>Custom Software</a></li>
                <li><a href="/#services" onClick={(e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }}>Cloud & DevOps</a></li>
                <li><a href="/#services" onClick={(e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }}>Embedded/IoT Systems</a></li>
                <li><a href="/#services" onClick={(e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }}>Computer Vision</a></li>
                <li><a href="/product-development">3D Printing</a></li>
              </ul>
            </Col>

            <Col lg={3} md={4} sm={12}>

              {/*<a href="https://accurati.youtrack.cloud" target="_blank" rel="noopener noreferrer" className="footer-cta">*/}
              {/*  Customer Portal <FaArrowRight className="ms-2" />*/}
              {/*</a>*/}
              <h3 className="footer-heading">Registered Office</h3>
              <ul className="footer-contact">
                {/*<li>*/}
                {/*  <FaMapMarkerAlt className="contact-icon" />*/}
                {/*  <span>Florianópolis, Brazil</span>*/}
                {/*</li>*/}
                <li>
                  <FaBuilding className="contact-icon" />
                  <span><b>Accurati Limited</b></span>
                </li>
                <li>
                  <FaEnvelope className="contact-icon" />
                  <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                </li>
                <li>
                  <FaInfo className="contact-icon" />
                  <span>Registered in Ireland (792538)</span>
                </li>
                <li>
                  <div className="contact-icon" >&nbsp;</div>
                  <span>6 Fern Road, Sandyford, Dublin</span>
                </li>
                {/*<p><b>Accurati Limited</b></p>*/}
                {/*<p>Registered in Ireland: 792538</p>*/}
                {/*<p><FaLocationDot/>&nbsp;6 Fern Road, Sandyford, Dublin</p>*/}
                {/*<p></p>*/}
                {/*<li>*/}
                {/*  <FaMapMarkerAlt className="contact-icon" />*/}
                {/*  <span>Dublin, Ireland</span>*/}
                {/*</li>*/}

              </ul>

            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-bottom">
        <Container>
          <Row>
            <Col md={6}>
              <p className="copyright">© {new Date().getFullYear()} ACCURATI LTD&nbsp;-&nbsp;All rights reserved.</p>
            </Col>
            <Col md={6} className="text-md-end">
              <p className="version">Version: {REACT_APP_VERSION}</p>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
